import { lazy } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import TrackChangesOutlined from '@mui/icons-material/TrackChangesOutlined';
import type { FeatureManifest } from '../registry';
import { color } from '../../design/tokens';
import { createSpace, restoreSpace, setSpaceBanner } from './api';
import type { NewSpaceAccessDto } from '../../../../shared/types/access';

const loadGoalSpacePage = () => import('./GoalSpacePage');
const GoalSpacePage = lazy(loadGoalSpacePage);

/** /g/:shareId/goals/:goalId is a friendly alias: the detail opens as a drawer on the overview. */
function GoalLink() {
    const { shareId, goalId } = useParams();
    return <Navigate replace to={`/g/${shareId}?goal=${encodeURIComponent(goalId ?? '')}`} />;
}

export const goalsFeature: FeatureManifest = {
    preload: loadGoalSpacePage,
    type: 'goalSpace',
    label: 'Goal space',
    plural: 'Goal spaces',
    tagline: 'Goals and key results in one shareable tree.',
    Icon: TrackChangesOutlined,
    accent: color.spark,
    pathPrefix: '/g',
    // Not immersive: the overview scrolls like a normal page
    routes: [
        { path: '/g/:shareId', element: <GoalSpacePage /> },
        { path: '/g/:shareId/goals/:goalId', element: <GoalLink /> },
    ],
    restore: shareId => restoreSpace(shareId),
    setBanner: (shareId, file) => setSpaceBanner(shareId, file),
    create: async (title: string, access: NewSpaceAccessDto) => ({ shareId: (await createSpace(title, access)).shareId }),
};
